import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container sm:mb-[120px] xs:mb-[80px]">
      <h2 className="bg-gradient-to-r font-faustina from-[#1FA2FF] from-[40%] via-45% to-[#A6FFCB] to-[58%] text-transparent bg-clip-text font-bold  xs:text-3xl lg:text-5xl text-center mb-[60px] flex flex-col gap-[24px] items-center justify-center">
        Privacy Policy
        <div className="lg:w-[15%] md:w-[17%] sm:w-[23%] 428:w-[27%] xs:w-[37%] h-1 bg-gradient-to-r from-sky-500 via-cyan-300 to-teal-200 rounded">
          {" "}
        </div>
      </h2>
      <div className="privacy-policy-content w-full flex justify-center">
        <div className="1500:w-[85%] sm:w-[90%] xs:w-[93%] text-justify content-inner flex flex-col sm:gap-10 xs:gap-[22px]">
          <div className="intro gap-5 flex flex-col">
            <p className="p-privacy-policy ">
              At Param Consulting Services Inc., accessible from http://param.us.com/, one of our
              top priorities is the privacy of our visitors. This Privacy Policy
              outlines the types of information collected and recorded by Param Consulting Services Inc. and how we use it.
            </p>
            <p className="p-privacy-policy">
              If you have any questions or need more information about our
              Privacy Policy, please don’t hesitate to contact us.
            </p>
            <p className="p-privacy-policy">
              This Privacy Policy applies only to our online activities and is
              valid for visitors to our website concerning the information they
              share and/or collect on Param Consulting Services Inc.. This policy does not apply to
              any information collected offline or through channels other than
              this website.
            </p>
          </div>

          <div className="consent flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina lg:text-[50px] xs:text-[clamp(30px,4.8vw,50px)] font-bold bg-gradient-to-r from-[#1FA2FF] from-[0%] to-[#A6FFCB] to-[20%] text-transparent bg-clip-text">
              Consent
            </h2>
            <p>
              By using our website, you hereby consent to our Privacy Policy and
              agree to its terms.
            </p>
          </div>

          <div className="information flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina xs:text-[clamp(30px,4.8vw,50px)] lg:text-[50px] font-bold bg-gradient-to-r from-[#1FA2FF] from-[0%] to-[#A6FFCB] to-[20%] text-transparent bg-clip-text">
              Information we collect
            </h2>
            <p>
              The personal information we ask you to provide, and the reasons
              for requesting it, will be clearly explained at the time of
              collection.
            </p>
            <p>
              If you contact us directly, we may receive additional information
              about you such as your name, email address, phone number, the
              contents of your message and any attachments you send, as well as
              any other information you choose to provide.
            </p>
            <p>
              When you register for an account, we may request your contact
              information, including your name, company name, address, email
              address, and telephone number.
            </p>
          </div>

          <div className="how-we-use flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina xs:text-[clamp(30px,4.8vw,50px)] lg:text-[50px] font-bold bg-gradient-to-r from-[#1FA2FF] from-[10%] to-[#A6FFCB] to-[30%] text-transparent bg-clip-text">
              How we use your information
            </h2>
            <div className="flex flex-col gap-5">
              <p>
                We use the information we collect in several ways, including to:
              </p>
              <ul>
                <li>Provide, operate, and maintain our website</li>
                <li>Improve, personalize, and expand our website</li>
                <li>Understand and analyze how you use our website</li>
                <li>
                  Develop new products, services, features, and functionality
                </li>
                <li>
                  Communicate with you, either directly or through one of our
                  partners, including for customer service, to provide you with
                  updates and other information related to the website, and for
                  marketing and promotional purposes.
                </li>
                <li>Send you emails</li>
                <li>Find and prevent fraud</li>
              </ul>
            </div>
          </div>

          <div className="log-files flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina xs:text-[clamp(30px,4.8vw,50px)] lg:text-[50px] font-bold bg-gradient-to-r from-[#1FA2FF] from-[0%] to-[#A6FFCB] to-[9%] text-transparent bg-clip-text">
              Log Files
            </h2>
            <p>
              Param Consulting Services Inc. follows a standard procedure of using log files to
              record visitors when they access our websites. This practice is
              common among all hosting companies and is part of hosting service
              analytics. The information collected by these log files includes
              internet protocol (IP) addresses, browser type, Internet Service
              Provider (ISP), date and time stamps, referring and exit pages,
              and possibly the number of clicks. This data is not linked to any
              personally identifiable information. The purpose of collecting
              this information is to analyze trends, administer the site, track
              users' movements on the website, and gather demographic
              information.
            </p>
          </div>

          <div className="advertising flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina xs:text-[clamp(30px,4.8vw,50px)] lg:text-[50px] font-bold bg-gradient-to-r from-[#1FA2FF] from-[0%] to-[#A6FFCB] to-[40%] text-transparent bg-clip-text">
              Advertising Partners Privacy Policies
            </h2>
            <p>
              You may consult this list to review the Privacy Policies of Param Consulting Services Inc. advertising partners.
            </p>
            <p>
              Third-party ad servers or ad networks use technologies such as
              cookies, JavaScript, or web beacons in their advertisements and
              links that appear on Param Consulting Services Inc.. These technologies are sent
              directly to users’ browsers and automatically receive your IP
              address when this occurs. They are used to measure the
              effectiveness of advertising campaigns and/or to personalize the
              advertising content you see on the websites you visit.
            </p>
            <p>
              Note that Param Consulting Services Inc. has no access to or control over the cookies
              used by third-party advertisers.
            </p>
          </div>

          <div className="third-party flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina xs:text-[clamp(30px,4.8vw,50px)] lg:text-[50px] font-bold bg-gradient-to-r from-[#1FA2FF] from-[0%] to-[#A6FFCB] to-[40%] text-transparent bg-clip-text">
              Third Party Privacy Policies
            </h2>
            <p>
              Param Consulting Services Inc.Privacy Policy does not apply to other advertisers
              or websites. Therefore, we advise you to consult the Privacy
              Policies of these third-party ad servers for more detailed
              information, including their practices and instructions on how to
              opt out of certain options.
            </p>
            <p>
              You can choose to disable cookies through your individual browser
              settings. For more detailed information about managing cookies
              with specific browsers, please visit the respective browser’s
              official website.
            </p>
          </div>

          <div className="ccpa-privacy-rights flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina xs:text-[clamp(30px,4.8vw,50px)] lg:text-[50px] font-bold bg-gradient-to-r from-[#1FA2FF] from-[0%] to-[#A6FFCB] to-[70%] text-transparent bg-clip-text">
              CCPA Privacy Rights (Do Not Sell My Personal Information)
            </h2>
            <div className="flex flex-col gap-5">
              <p>
                Under the CCPA, California residents are entitled to the
                following rights:
              </p>
              <ul>
                <li>
                  Request that a business that collects a consumer's personal
                  data disclose the categories and specific pieces of personal
                  data that the business has collected about consumers.
                </li>
                <li>
                  Request that a business delete any personal data about the
                  consumer that the business has collected.
                </li>
                <li>
                  Request that a business that sells a consumer's personal data
                  does not sell the consumer's personal data.
                </li>
                <li>
                  If you make a request, we have one month to respond to you. If
                  you would like to exercise any of these rights, please contact
                  us.
                </li>
              </ul>
            </div>
          </div>

          <div className="gdpr-data-protection flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina xs:text-[clamp(30px,4.8vw,50px)] lg:text-[50px] font-bold bg-gradient-to-r from-[#1FA2FF] from-[0%] to-[#A6FFCB] to-[40%] text-transparent bg-clip-text">
              GDPR Data Protection Rights
            </h2>
            <p>
              We want to ensure that you are fully aware of all your data
              protection rights. Every user is entitled to the following:
            </p>
            <ul>
              <li>
                The right to access – You have the right to request copies of
                your personal data. We may charge a small fee for this service.
              </li>
              <li>
                The right to rectification – You have the right to request that
                we correct any information you believe is inaccurate. You also
                have the right to request that we complete any information you
                believe is incomplete.
              </li>
              <li>
                The right to erasure – You have the right to request that we
                erase your personal data under certain conditions.
              </li>
              <li>
                The right to restrict processing – You have the right to request
                that we restrict the processing of your personal data under
                certain conditions.
              </li>
              <li>
                The right to object to processing – You have the right to object
                to our processing of your personal data under certain
                conditions.
              </li>
              <li>
                The right to data portability – You have the right to request
                that we transfer the data we have collected to another
                organization, or directly to you, under certain conditions.
              </li>
            </ul>
            <p>
              If you make a request, we have one month to respond to you. If you
              would like to exercise any of these rights, please contact us.
            </p>
          </div>

          <div className="childrens-info flex flex-col sm:gap-6 xs:gap-[22px]">
            <h2 className="font-faustina xs:text-[clamp(30px,4.8vw,50px)] lg:text-[50px] font-bold bg-gradient-to-r from-[#1FA2FF] from-[0%] to-[#A6FFCB] to-[30%] text-transparent bg-clip-text">
              Children's Information
            </h2>
            <p>
              Another part of our priority is adding protection for children
              while using the internet. We encourage parents and guardians to
              observe, participate in, and/or monitor and guide their online
              activity.
            </p>
            <p>
              Param Consulting Services Inc. does not knowingly collect any personally identifiable
              information from children under the age of 13. If you believe that
              your child has provided this kind of information on our website,
              we strongly encourage you to contact us immediately, and we will
              make our best efforts to promptly remove such information from our
              records.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
